// Reject leading-zero integers so codes like "0123" stay as-is.
const NUMERIC_CELL_RE = /^-?(?:0|[1-9]\d*)(?:\.\d+)?$/;

// Returns a comma-separated en-US string for plain numeric cell values,
// preserving the source's decimal count. Returns null for anything that
// isn't a pure number — callers fall through to the raw value.
export const formatCellNumber = (value: unknown): string | null => {
  if (value == null) return null;
  if (typeof value !== 'string' && typeof value !== 'number') return null;
  const str = String(value).trim();
  if (!str || !NUMERIC_CELL_RE.test(str)) return null;
  const n = Number(str);
  if (!Number.isFinite(n) || Math.abs(n) >= Number.MAX_SAFE_INTEGER) return null;
  const decimals = str.match(/\.(\d+)$/)?.[1].length ?? 0;
  return n.toLocaleString('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: Math.min(decimals, 20)
  });
};
